import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import {
  useDateLocale,
  useFloatingSelect,
  useTimeZone,
} from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../../Button'
import { FloatingSelectDropdown, FloatingTrigger } from '../../../Floating'
import { ICON_HEIGHT_16 } from '../../../Icon'
import { ScrollContainer } from '../../../ScrollContainer'
import Text from '../../../Text'

import { DROPDOWN_STYLES } from './EmailProfileMessageHeaderSenderAdditionalInfoTo.constants'
import {
  getDropdownData,
  getToStringValue,
} from './EmailProfileMessageHeaderSenderAdditionalInfoTo.utils'

import * as styles from './EmailProfileMessageHeaderSenderAdditionalInfoTo.module.css'

import DropdownIcon from '../../../../icons/dropdown.svg'

function EmailProfileMessageHeaderSenderAdditionalInfoTo({
  className = styles.EmailProfileMessageHeaderSenderAdditionalInfoTo,
  data,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({
      dropdownStyles: DROPDOWN_STYLES,
      placement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
    })

  function handleToggleTo(event) {
    stopPropagation(event)

    setOpen(prev => !prev)
  }

  const toText = getToStringValue(data)

  const dropdownData = data
    ? getDropdownData({
        data,
        locale,
        t,
        timezone,
      })
    : null

  return (
    <FloatingTrigger context={context}>
      <div className={className}>
        <Text isSecondary className={styles.toLabel}>
          {t('EmailProfile.LetterToLabelKey')}
        </Text>
        <ButtonArrow
          className={styles.toButton}
          getTooltip={null}
          height={BUTTON_HEIGHT_24}
          iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
          iconProps={{
            height: ICON_HEIGHT_16,
            iconProps: { Icon: DropdownIcon },
          }}
          isInline={false}
          isOpen={isOpen}
          text={toText}
          onClick={handleToggleTo}
        />
        <FloatingSelectDropdown
          context={context}
          floatingStyles={floatingStyles}
          getFloatingProps={getFloatingProps}
          isOpen={isOpen}
          refs={refs}
        >
          <ScrollContainer className={styles.dropdown}>
            {dropdownData.map(item => (
              <div className={styles.row} key={item.label}>
                <div className={styles.label}>{item.label}</div>
                {Array.isArray(item.value) ? (
                  <div className={styles.values}>
                    {item.value.map((value, index) => (
                      <Text className={styles.value} key={index}>
                        {value.label}
                      </Text>
                    ))}
                  </div>
                ) : (
                  <Text className={styles.value}>{item.value}</Text>
                )}
              </div>
            ))}
          </ScrollContainer>
        </FloatingSelectDropdown>
      </div>
    </FloatingTrigger>
  )
}

export default EmailProfileMessageHeaderSenderAdditionalInfoTo
